import React from 'react';
import styles from './CustomButton.module.scss';

const CustomButton = ({
	children,
	onClick,
	//width of the element
	width,
	//height of the element
	height,
	//button type: ex - button, submit, etc
	type,
	//form ID - usually used to select a submit type button with and ID outside of the parent
	form,
	//determine whether to disable the button or not
	disabled,
	//change background to outlined
	outlined,
	//add hover effect
	hovered,
}) => {
	return (
		<button
			className={`${styles.custom_btn}  ${outlined && styles.outlined} ${
				hovered && outlined ? styles.hovered_outlined : ''
			} ${hovered && !outlined ? styles.hovered : ''}`}
			onClick={onClick}
			style={{ width: `${width}px`, height: `${height}px` }}
			type={type}
			form={form}
			disabled={disabled}
		>
			{children}
		</button>
	);
};

export default CustomButton;
